import React from "react";

interface FooterLinkProps {
  text: string;
  destination: string;
}

const FooterLink: React.FC<FooterLinkProps> = ({ text, destination }) => {
  // Combine all the classes for the link
  const linkClasses = [
    "h-7",
    "inline-flex",
    "justify-center",
    "items-center",
    "gap-2.5",
    "text-base",
    "font-medium",
    "font-['Manrope']",
    "leading-7",
    "tracking-tight",
    "text-[#04262b]", // Default text color
    "hover:text-[#454846]", // Hover text color
  ].join(" ");

  return (
    <a href={destination} className={linkClasses}>
      {text}
    </a>
  );
};

export default FooterLink;
